import { Component } from '@angular/core';
import { ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'demo-application-shell',
    templateUrl: './demo-application-shell.html',
    styleUrls: ['./demo-common.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemoApplicationShellComponent {
    menuMode: 'show' | 'hide' = 'hide';
    panelSize: 'small' | 'large' | 'auto' = 'auto';
    panelLines: 'show' | 'hide' = 'hide';
    headerColor = 'warning';
    headerMenu: 'show' | 'hide' = 'show';

    colors = ['primary', 'secondary', 'tertiary', 'success', 'warning', 'danger', 'medium', 'dark'];

    toggleMenu() {
        this.menuMode = this.menuMode === 'show' ? 'hide' : 'show';
    }

    cyclePanelSize() {
        const sizes: Array<'small' | 'large' | 'auto'> = ['auto', 'small', 'large'];
        const idx = sizes.indexOf(this.panelSize);
        this.panelSize = sizes[(idx + 1) % sizes.length];
    }

    togglePanelLines() {
        this.panelLines = this.panelLines === 'show' ? 'hide' : 'show';
    }

    toggleHeaderMenu() {
        this.headerMenu = this.headerMenu === 'show' ? 'hide' : 'show';
    }
}
